import TextCell from 'components/TextCell';
import type { ManagedFleet } from '../..';

interface StateCellProps {
  rowData: ManagedFleet;
}

export default function StateCell({ rowData: { state } }: StateCellProps) {
  return <TextCell text={state} />;
}
